export default "__VITE_ASSET__DLp4pn0F__"